export default __webpack_public_path__ + "static/media/conventus-2.0eff77fc.png";